module.exports = __webpack_public_path__ + "static/WildCard-City-Logo-c988572eee70c3fa67e712807c7fa612.jpg";